import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ContentSizeSubscribeService {

  constructor() { }
  private sizeSubject = new Subject();

  public sizeChange(): void {
    this.sizeSubject.next();
  }

  public getObservable(): Observable<any> {
    return this.sizeSubject.asObservable();
  }
}
